module.exports = __webpack_public_path__ + "static/media/rv-parking-bg.7e9faa34.jpeg";